import { ADTeamConfig } from './adTeam/config'
import { ArticleConfig } from './article/config'
import { CareServiceConfig } from './careService/config'
import { ClinicConfig } from './clinic/config'
import { CooperationPartnerConfig } from './cooperationPartner/config'
import { CostCarrierConfig } from './costCarrier/config'
import { DoctorConfig } from './doctor/config'
import { HospiceConfig } from './hospice/config'
import { MedicalSupplyHomeConfig } from './medicalSupplyHome/config'
import { MedicalTechnologyConfig } from './medicalTechnology/config'
import { NursingHomeConfig } from './nursingHome/config'
import { patientConfig } from './patient/config'
import { PatientFormConfig } from './patientForm/config'
import { PharmacyConfig } from './pharmacy/config'
import { UserConfig } from './user/config'

export const entityRegistry = {
  patient: patientConfig,
  pharmacy: PharmacyConfig,
  clinic: ClinicConfig,
  doctor: DoctorConfig,
  costCarrier: CostCarrierConfig,
  careService: CareServiceConfig,
  hospice: HospiceConfig,
  nursingHome: NursingHomeConfig,
  medicalTechnology: MedicalTechnologyConfig,
  medicalSupplyHome: MedicalSupplyHomeConfig,
  adTeam: ADTeamConfig,
  article: ArticleConfig,
  user: UserConfig,
  cooperationPartner: CooperationPartnerConfig,
  patientForm: PatientFormConfig,
} as const

export type EntityRegistry = typeof entityRegistry
export type EntityName = keyof typeof entityRegistry

export const isEntityName = (value: string): value is EntityName => value in entityRegistry

export const getEntity = <Name extends EntityName>(name: Name): EntityRegistry[Name] => entityRegistry[name]

export const findEntity = (value: string): EntityRegistry[EntityName] | undefined =>
  isEntityName(value) ? entityRegistry[value] : undefined

export const entityLabel = (entity: EntityName): string => entityRegistry[entity].label
